import { getInstance } from '@module-federation/runtime';
import { encodeName, MFPrefetchCommon, } from '@module-federation/sdk';
export const getScope = () => {
    return getInstance().options.name;
};
export const getPrefetchId = (id) => encodeName(`${id}/${MFPrefetchCommon.identifier}`);
export const compatGetPrefetchId = (id) => encodeName(`${id}/VmokPrefetch`);
export const getSignalFromManifest = (remoteSnapshot) => {
    if (!remoteSnapshot) {
        return false;
    }
    if (!('prefetchEntry' in remoteSnapshot) &&
        !('prefetchInterface' in remoteSnapshot)) {
        return false;
    }
    if (!remoteSnapshot.prefetchEntry && !remoteSnapshot.prefetchInterface) {
        return false;
    }
    return true;
};
